//@ts-nocheck
import React from 'react'

import {
  Body2,
  COLORS,
  Layout,
  Spacer,
  TitleMedium2,
} from 'ethos-design-system'
import PropTypes from 'prop-types'

import { LICENSES_LABELS } from '../../constants'
import styles from './Licenses.module.scss'

/**
 * Licenses module
 *
 * @param {object} moduleData - Result of the LicensesQuery
 */
const Licenses = ({ moduleData }) => {
  const { blocks } = moduleData

  if (!blocks || blocks.length < 1) {
    console.error('No blocks in Licenses module data!')
    return null
  }

  const Block = ({ state, dba, entity, producer, tpa }) => {
    return (
      <div className={styles.Block}>
        <TitleMedium2.Sans.Medium500 color={COLORS.BRAND_FOREST}>
          {state}
        </TitleMedium2.Sans.Medium500>
        {dba && (
          <>
            <div className={styles.Eyebrow}>{LICENSES_LABELS.DBA}</div>
            <Body2.Regular400>{dba}</Body2.Regular400>
            <Spacer.H16 />
          </>
        )}
        {entity && (
          <>
            <div className={styles.Eyebrow}>{LICENSES_LABELS.ENTITY}</div>
            <Body2.Regular400>{entity}</Body2.Regular400>
            <Spacer.H16 />
          </>
        )}
        {producer && (
          <>
            <div className={styles.Eyebrow}>{LICENSES_LABELS.PRODUCER}</div>
            <Body2.Regular400>{producer}</Body2.Regular400>
            <Spacer.H16 />
          </>
        )}
        {tpa && (
          <>
            <div className={styles.Eyebrow}>{LICENSES_LABELS.TPA}</div>
            <Body2.Regular400>{tpa}</Body2.Regular400>
          </>
        )}
      </div>
    )
  }

  Block.propTypes = {
    state: PropTypes.string.isRequired,
    dba: PropTypes.string,
    entity: PropTypes.string,
    producer: PropTypes.string,
    tpa: PropTypes.string,
  }

  return (
    <Layout.HorizontallyPaddedContainer>
      <div className={styles.Blocks}>
        {blocks.map((block, index) => (
          <Block
            key={index}
            state={block.state}
            dba={block.dba}
            entity={block.entity}
            producer={block.producer}
            tpa={block.tpa}
          />
        ))}
      </div>
    </Layout.HorizontallyPaddedContainer>
  )
}

Licenses.propTypes = {
  moduleData: PropTypes.shape({
    type: PropTypes.string.isRequired,
    blocks: PropTypes.arrayOf(
      PropTypes.shape({
        state: PropTypes.string.isRequired,
        dba: PropTypes.string,
        entity: PropTypes.string,
        producer: PropTypes.string,
        tpa: PropTypes.string,
      })
    ).isRequired,
  }),
}

export default Licenses
